<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('expediente_cambios.list.title')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="ExpedienteCambio"
        :tableCode="'EXPEDIENTECAMBIO'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['idExpediente', 'codigo', 'fechaCambio']"
        :massiveActions="false"
        :funcShowCheck="showCheckInList"
        :controlsWidth="100"
        :searchOnInit="searchOnInit"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="'Ver inspección'" icon-f7="eye" color="green" :href="`/inspecciones/view/${item.idExpediente}/`" target="_blank"></f7-link>
        </template>
      </r-dynamic-list>
      <!-- rList Table CARD-->
    </f7-page-content>
    
  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<style>
  .badge-campo {
    margin-top: 5pt;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
  .badge-campo-title {
    font-size: 7pt;
    height: 7pt;
    position: absolute;
    top: -4pt;
    left: 11pt;
    background-color: transparent;
  }
  .badge-success {
    color: #fff;
    background-color: #00ff3c;
  }
  .badge-danger {
    color: #fff;
    background-color: #ff0019;
  }
  .badge-info {
    color: #fff;
    background-color: #17a2b8;
  }

  .comprobaciones {
    /* color: #fff; */
    /* background-color: #d3851e; */
    color: #d31e1e;
  }
  .caracteristicas {
    /* color: #fff; */
    /* background-color: #2747d6; */
    color: #2747d6;
  }
</style>
<script>

import rDynamicList from "../../components/rDynamicList.vue";
import ExpedienteCambio from "../../js/db/ExpedienteCambio.js";
import Utils from "../../js/Utils.js";
import CacheService from '../../js/db/Cache.js';

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      ExpedienteCambio,
      Utils,
    };
  },
  props: {
    searchOnInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    showCheckInList: function(item) {
      return false; 
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
  }
};
</script>